// tourData.js

export const data = {
  TourListing: [
    {
      id: 1,
      imageSrc: "/images/homepage/product1.jpg",
      discount: "-10%",
      newRating: "4.5",
      title: "Dubai Airport Private Transfer",
      description: "Discover all of Dubai’s top sights with a private tour guide during this full-day city tour. Go back in time and learn about the humble beginnings of the desert city in Old Dubai, including a boat ride aboard an “abra.” Then, see modern sights including Dubai Marina, Burj Al Arab, and tickets.",
      hastag: "#1 Top Dubai Desert Experience",
      logo1: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211949/choise2_hxevxq.png",
      logo2: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211949/choise2_hxevxq.png",
      location: "Dubai, United Arab Emirates",
      tour_tour_price_aed: "1,215",
      person: "",
      tour_tour_duration: "1 Hour",
    },
    {
      id: 2,
      imageSrc: "/images/homepage/product2.jpg",
      discount: "-20%",
      newRating: "5",
      title: "6 Hours Dubai Private City Tour",
      description: "Our six hour trip is especially designed for any tourist or visitor on a short stay.",
      location: "Dubai, United Arab Emirates",
      tour_tour_price_aed: "1,020",
      person: "3",
      tour_tour_duration: "6 Hours",
    },
    {
      id: 3,
      //imageSrc:process.env.PUBLIC_URL + "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product3_nc0kot.jpg",
      imageSrc: "/images/homepage/product3.jpg",
      discount: "-10%",
      newRating: "3.5",
      title: "3 Hours Morning Desert Safari",
      description: "The Morning Safari is organized daily throughout the week.",
      location: "Dubai, United Arab Emirates",
      tour_tour_price_aed: "1,075",
      person: "4",
      tour_tour_duration: "3 Hours",
    },
    {
      id: 4,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product4_amof0v.jpg",
      discount: "",
      title: "Tandem Skydive",
      newRating: "2.5",
      description: "A tandem skydive is the quickest and easiest way to experience.",
      location: "Dubai, United Arab Emirates",
      logo2: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211949/choise3_u3nlou.png",
      tour_tour_price_aed: "2,199",
      person: "",
      tour_tour_duration: "4 Hours",
    },
    {
      id: 5,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product5_dt22ld.jpg",
      discount: "-15%",
      title: "Seaplane Tour",
      newRating: "4",
      description: "Take your pick from two convenient take-off locations, Jebel Ali or Dubai Creek.",
      location: "Dubai, United Arab Emirates",
      tour_tour_price_aed: "4,553",
      person: "",
      tour_tour_duration: "4 Hours",
    },
    {
      id: 6,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product6_vsdja8.jpg",
      discount: "-25%",
      newRating: "3",
      title: "Luxury Yacht Charter",
      description: "We at Dubai Private tour provide Luxury Yachts charter services in Dubai Marina.",
      location: "Dubai, United Arab Emirates",
      hastag: "#1 Top Dubai Desert Experience",
      tour_tour_price_aed: "250",
      person: "5 ",
      tour_tour_duration: "6 Days",
    },
    {
      id: 7,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product7_uno5an.jpg",
      discount: "-10%",
      newRating: "4.5",
      title: "Dubai Airport Private Transfer",
      description: "We promise, to give you a warm welcome and make you feel comfortable and safe.",
      location: "Dubai, United Arab Emirates",
      logo2: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211949/choise2_hxevxq.png",
      tour_tour_price_aed: "2,151",
      person: "3",
      tour_tour_duration: "1 Hour",
    },
    {
      id: 8,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211166/product8_v6aw0h.jpg",
      discount: "-20%",
      newRating: "5",
      title: "6 Hours Dubai Private City Tour",
      description: "Our six-hour trip is especially designed for any tourist or visitor on a short stay.",
      location: "Dubai, United Arab Emirates",
      logo1: 'https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211949/choise2_hxevxq.png',
      logo2: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211949/choise2_hxevxq.png",
      tour_tour_price_aed: "1,020",
      person: "",
      tour_tour_duration: "6 Hours",
    },
    {
      id: 9,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product5_dt22ld.jpg",
      discount: "-10%",
      newRating: "4",
      title: "3 Hours Morning Desert Safari",
      description: "The Morning Safari is organized daily throughout the week.",
      location: "Dubai, United Arab Emirates",
      tour_tour_price_aed: "3,303",
      person: " 4",
      tour_tour_duration: "3 Hours",
    },
    {
      id: 10,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product2_oql3sj.jpg",
      discount: "",
      newRating: "5",
      title: "Tandem Skydive",
      description: "A tandem skydive is the quickest and easiest way to experience.",
      location: "Dubai, United Arab Emirates",
      tour_tour_price_aed: "2,199",
      person: "",
      tour_tour_duration: "4 Hours",
    },
    {
      id: 11,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product4_amof0v.jpg",
      discount: "-15%",
      newRating: "4.5",
      title: "Seaplane Tour",
      description: "Take your pick from two convenient take-off locations, Jebel Ali or Dubai Creek.",
      location: "Dubai, United Arab Emirates",
      logo2: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211949/choise2_hxevxq.png",
      hastag: "#1 Top Dubai Desert Experience",
      tour_tour_price_aed: "5,000",
      person: "",
      tour_tour_duration: "1 Day",
    },
    {
      id: 12,
      imageSrc: "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698211165/product5_dt22ld.jpg",
      discount: "-25%",
      newRating: "1",
      title: "Luxury Yacht Charter",
      description: "We at Dubai Private tour provide Luxury Yachts charter services in Dubai Marina.",
      location: "Dubai, United Arab Emirates",
      tour_tour_price_aed: "2,500",
      person: "5",
      tour_tour_duration: "2 Days",
    }
    // Add more tour items here
  ],
  CategoryList: [
    {
      category: "Luxury Tours"
    },
    {
      category: "Budget City Tour"
    },
    {
      category: "Dinner Cruise"
    },
    {
      category: "Skydive Dubai"
    },
    {
      category: "Dune Buggy"
    },
    {
      category: "Airport Transfers"
    },

    {
      category: "Budget Airport Layover Tour"
    },
    {
      category: "Burg Al Arab Reservations"
    },
    {
      category: "City Tours"
    },
    {
      category: "Desert Safari"
    },
    {
      category: "Expo 2020 Packages"
    },
    {
      category: "Meet Local Emirati"
    },
    {
      category: "Seaplane Tour"
    },
    {
      category: "Ferrari World"
    },
    {
      category: "Attractions Tickets"
    },
    {
      category: "Budget Desert Safaris"
    },
    {
      category: "Airport Transfers"
    },

    {
      category: "Budget Airport Layover Tour"
    },
    {
      category: "Hot Air Balloon"
    },
    {
      category: "Luxury Yacht Charter"
    },
    {
      category: "Hotel Bookings"
    },
    {
      category: "Helicopter Tour"
    },
    {
      category: "Burj Khalifa Reservations"
    },
    {
      category: "Stable Tour"
    },



  ]
};
